import _ from 'lodash';
import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { Button, Form, Input, message, Popconfirm, Select, Table, Typography } from 'antd';

import { amlOptions, communityMediaOptions, foundersTeamOptions, lawsuitsOptions, reputationOptions } from './StaticTexts/dropdown';
import { ListingGeneralKeysThunk, ListingGeneralValueThunk } from '../../Store/Thunks/ListingGeneralThunk';
import { splitStringIntoTwoLines } from '../../Helpers/ValueFormater';
import ReloadIcon from "../../Assets/img/icons/refresh.png";
import { ApiPutListingGeneralValue} from '../../Services';
import { _capitalize } from 'chart.js/helpers';

const EditableCell = ({
  editing,
  dataIndex,
  title,
  record,
  ListingGeneralValueData,
  ...restProps
}) => {
  const options = dataIndex === "foundersOrTeam"
    ? foundersTeamOptions
    : dataIndex === "reputation"
    ? reputationOptions
    : dataIndex === "lawsuits"
    ? lawsuitsOptions
    : dataIndex === "aml"
    ? amlOptions
    : communityMediaOptions;

  const keysToCheck = [
    "foundersOrTeam",
    "reputation",
    "aml",
    "lawsuits",
    "communityOrMedia"
  ];

  const isHasKey = keysToCheck.includes(dataIndex);

  return (
    <td {...restProps}>
      {editing ? (
        isHasKey ? (
          <>
            <Form.Item
              name={[record.key, `${dataIndex}Level`]}
              style={{ margin: 0 }}
            >
              <Select>
                {Object.keys(options).map(key => (
                  <Select.Option key={options[key].value} value={options[key].value} style={options[key].style}>
                    {options[key].label}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item
              name={[record.key, dataIndex]}
              style={{ margin: 0 }}
            >
              <Input />
            </Form.Item>
          </>
        ) : (
          <Form.Item
            name={[record.key, dataIndex]}
            style={{ margin: 0 }}
          >
            <Input />
          </Form.Item>
        )
      ) : (
        restProps.children
      )}
    </td>
  );
};


export const General = () => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [editingKey, setEditingKey] = useState('');
  const [isSaveClicked, setIsSaveClicked] = useState(false);
  const [modifiedRows, setModifiedRows] = useState(new Set());
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [bulkEditing, setBulkEditing] = useState(false);
  const [cellToggleState, setCellToggleState] = useState({}); 

  useEffect(() => {
    dispatch(ListingGeneralKeysThunk());
    dispatch(ListingGeneralValueThunk());
  }, []);

  const {
    ListingGeneralKeyData,
    ListingGeneralKeyLoading,
    ListingGeneralValueData,
    ListingGeneralValueLoading,
    ListingGeneralValueError,
    ListingGeneralKeyError
  } = useSelector((state) => state.ListingGeneralReducer);
  
  const isEditing = (record) => bulkEditing || record.key === editingKey;

    const edit = (record) => {
      const { key, ...rest } = record;
      form.setFieldsValue({
        [key]: rest,
      });
      setEditingKey(key);
    };
  

      const cancel = () => {
        setEditingKey('');
      };
      useEffect(() => {
          if (ListingGeneralKeyError) {
            message.error(`Error: ${ListingGeneralKeyError}`);
          }
          if (ListingGeneralValueError) {
            message.error(`Error: ${ListingGeneralValueError}`);
          }
        }, [ListingGeneralKeyError, ListingGeneralValueError]);

  const dataSource = () => {
    const arr = [];
    ListingGeneralValueData.map((item, index) => {    
      const obj = {};
      ListingGeneralKeyData.map((element) => {
        const key = element.key;
        const manualKey = `${key}Manual`;
        const cellKey = `${item.listingGeneral.id}_${key}`;
        if (item.listingGeneral) {         
          obj[element.key] = item.listingGeneral[element.key];
          if( (element.key !== "telegram" && element.key !=="reddit" && element.key !=="twitter")){
          obj[`${element.key}Level`] = item.listingGeneral[`${element.key}Level`];
          }

          const manualDataExists = item.listingGeneral[manualKey] && item.listingGeneral[manualKey] != 0;
    
                obj[`${key}_automatic`] = item.listingGeneral[key];  
                obj[key] = manualDataExists
                  ? item.listingGeneral[manualKey]
                  : item.listingGeneral[key];  
             
          obj[`${key}_hasManualData`] = manualDataExists ? true : false;
          obj.id = item.listingGeneral.id;
        } else {       
          obj[element.key] = "";
          if( (element.key !== "telegram" && element.key !=="reddit" && element.key !=="twitter")){
          obj[`${element.key}Level`] = "";
          }
          obj.id = item.id;
        }
      });
      
      arr.push({
        name: item.assetName,
        ...obj,
        key: index,
      });
    });
      
    setData(arr);
    return arr;
  };

  useEffect(() => {
    if (ListingGeneralKeyData?.length && ListingGeneralValueData.length) {
      dataSource();
    }
  }, [ListingGeneralKeyData, ListingGeneralValueData,cellToggleState]);

  const editAssetValue = () => {
    setLoading(true);

    const editData = Array.from(modifiedRows).reduce((acc, cellId) => {
      if (typeof cellId !== "string") return acc;
      const [rowId, colKey] = cellId.split('_');
      const row = data.find(item => item.id === parseInt(rowId, 10));
      if (!row) return acc;

      let newItem = acc.find(item => item.id === row.id);
      if (!newItem) {
        newItem = { id: row.id };
        acc.push(newItem);
      }

      const value = row[colKey];
      const manualKey = `${colKey}Manual`;

      if (['foundersOrTeam', 'reputation', 'aml', 'lawsuits', 'communityOrMedia'].includes(colKey)) {
        newItem[colKey] = value;
      } else {
        if (['telegram', 'reddit', 'twitter', 'githubCommits', 'googleSearchTrend'].includes(colKey)) {
          newItem[manualKey] = value ? Number(value.replace(/,/g, "")) : 0;
        } else {
          newItem[colKey] = value;
        }
      }

      return acc;
    }, []);

    if (!editData.length) return setLoading(false);

    ApiPutListingGeneralValue({ generals: editData })
      .then(() => {
        setLoading(false);
        setModifiedRows(new Set());
        dispatch(ListingGeneralKeysThunk());
        dispatch(ListingGeneralValueThunk());
      })
      .catch(() => {
        setLoading(false);
      });
  };
 
   const save = async (key) => {
    try {
      const values = await form.validateFields();
      const rowValues = values[key];

      const newData = [...data];
      const index = newData.findIndex(item => item.key === key);
      if (index > -1) {
        const item = newData[index];

        Object.keys(rowValues).forEach(colKey => {
          if (rowValues[colKey] !== item[colKey]) {
            item[colKey] = rowValues[colKey];
            setModifiedRows(prev => new Set(prev).add(`${item.id}_${colKey}`));
          }
        });

        newData[index] = { ...item };
        setData(newData);
        setEditingKey('');
        setIsSaveClicked(true);
      }
    } catch (err) {
      console.log('Validate Failed: ', err);
    }
  };

  useEffect(()=>{
    if(modifiedRows && isSaveClicked){
      editAssetValue();
    }
    setIsSaveClicked(false)
  },[modifiedRows,isSaveClicked])


const handleToggleCellData = async (rowId, colKey) => {
  const cellKey = `${rowId}_${colKey}`;
  setCellToggleState((prevState) => ({
    ...prevState,
    [cellKey]: !prevState[cellKey],
  }));

// Prepare data to remove manual entry
const row = data.find((item) => item.id === rowId);
if (!row) return;

const manualKey = `${colKey}Manual`;
const newItem = { id: row.id, [manualKey]: null }; 

// Call API to remove manual data
   setLoading(true);
   try {
     await ApiPutListingGeneralValue({ generals: [newItem] });
     setModifiedRows((prev) => {
       const newSet = new Set(prev);
       newSet.delete(cellKey); // Remove the cell from modified rows after save
       return newSet;
     });
      // Fetch updated data from the backend
      dispatch(ListingGeneralKeysThunk());
      dispatch(ListingGeneralValueThunk());
 
   } catch (error) {
     console.error("Failed to update manual data:", error);
   } finally {
     setLoading(false);
   }
};

  const columns = () => {
    return [
      {
        title: "#",
        dataIndex: "index",
        key: "index",
        width: 60,
        render: (text, record, index) => index + 1,
      },
      {
        title: 'Asset',
        dataIndex: 'name',
        fixed: 'left',
        width: 100,

      },
      ...ListingGeneralKeyData.map((item) => ({
        title: item.key !== 'twitter' ? splitStringIntoTwoLines(item.name) :item.name,
        dataIndex: item.key,
        editable: true,

        render: (text, record) => {
          const formatNumber = (value) => {
            return Number(value)
              .toFixed(0)
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
          };
          const hasManualData = record[`${item.key}_hasManualData`];
          const automaticValue = record[`${item.key}_automatic`];

          const showAutomaticSymbol =
            hasManualData &&
            automaticValue !== null &&
            automaticValue !== undefined && automaticValue !== "0";
          const cellKey = `${record.id}_${item.key}`;
          const isManualDataDisplayed = cellToggleState[cellKey];
          return (
            <>
              {record[`${item.key}Level`] && (
                <p style={{ fontWeight: 'bold' }}>{record[`${item.key}Level`]}</p>
              )}
        <span style={{ color: (hasManualData ) ? "#1890ff" : "#000" }}>
              {text && /^\d+(\.\d+)?$/.test(text) ? (
                text !== 0 ? formatNumber(text) : null
              ) : ( 
                text
              )}
        </span>

            {showAutomaticSymbol && (
                  <span className="has_automatic" title={formatNumber(automaticValue)}>A</span>
                ) }

              {hasManualData && (
                <img
                  src={ReloadIcon}
                  alt="Reload"
                  style={{
                    width: "20px",
                    position: 'absolute',
                    top: "15px",
                    right: "10px",
                    transform: 'translateY(-50%)'
                  }}
                  onClick={() => handleToggleCellData(record.id, item.key)}
                />
              )}
            </>
          );
        }
                
      })),
      {
        title: 'Operation',
        dataIndex: 'operation',
        fixed: 'right',
        width: 100,
        render: (_, record) => {
          const editable = isEditing(record);         
          return editable && !bulkEditing  ? (
            <span>
              <Typography.Link
                onClick={() => save(record.key)}
                style={{ marginRight: 8 }}
              >
                Save
              </Typography.Link>
                <Popconfirm
                                 title="Sure to cancel?"
                                 okText="Cancel"
                                 cancelText="No"
                                 okButtonProps={{ style: { float: 'right' } }}
                                 cancelButtonProps={{ style: { float: 'left' } }}
                                 onConfirm={cancel}
                                   overlayStyle={{ paddingBottom:"20px" }}
                               >
                                 <a>Cancel</a>
                        </Popconfirm>
            </span>
          ) : !bulkEditing  ? (
            <Typography.Link disabled={editingKey !== ''} onClick={() => edit(record)}>
              Edit
            </Typography.Link>
          ):
          null
        },
      },
    ];
  };

// Bulk edit  
const mergedColumns = columns().map((col) => {
    if (!col.editable) return col;
    return {
      ...col,
      onCell: (record) => ({
        record,
        inputType: col.inputType,
        dataIndex: col.dataIndex,
        title: col.title,
        editing: isEditing(record),
        ListingGeneralValueData
      }),
    };
  });
const rowSelection = {
    selectedRowKeys,
    onChange: (keys) => setSelectedRowKeys(keys),
    getCheckboxProps: (record) => ({
      disabled: editingKey !== '' && !selectedRowKeys.includes(record.key),
    }),
  };

  const bulkEdit = () => {
    const values = {};
    data.forEach(row => {
      if (selectedRowKeys.includes(row.key)) values[row.key] = row;
    });
    form.setFieldsValue(values);
    setBulkEditing(true);
  };const bulkSave = async () => {
    try {
      const values = await form.validateFields();
      const newData = [...data];
      const newModified = new Set(modifiedRows);

      Object.keys(values).forEach(rowKey => {
        const index = newData.findIndex(r => r.key === Number(rowKey));
        if (index === -1) return;
        const row = newData[index];
        const rowValues = values[rowKey];

        Object.keys(rowValues).forEach(colKey => {
          if (row[colKey] !== rowValues[colKey]) {
            newModified.add(`${row.id}_${colKey}`);
            row[colKey] = rowValues[colKey];
          }
        });
      });

      setData(newData);
      setModifiedRows(newModified);
      setBulkEditing(false);
      setSelectedRowKeys([]);
      setIsSaveClicked(true);
    } catch (e) {
      console.log(e);
    }
  };

  return (
   <div>
      <Form form={form} component={false}>
        <Table
          loading={ListingGeneralKeyLoading || ListingGeneralValueLoading || loading}
          rowSelection={rowSelection}
          components={{ body: { cell: EditableCell } }}
          className="custom-scroll"
          pagination={false}
          bordered
          dataSource={data}
          columns={mergedColumns}
          rowClassName="editable-row"
          scroll={{ y: 500 }}
        />
      </Form>

      <div style={{ marginTop: 16 }}>
        <Button disabled={!selectedRowKeys.length || editingKey !== ''} onClick={bulkEdit}>
          Bulk Edit
        </Button>
        {bulkEditing && (
          <>
            <Button type="primary" style={{ marginLeft: 8 }} onClick={bulkSave}>
              Bulk Save
            </Button>
            <Button style={{ marginLeft: 8 }} onClick={() => { setBulkEditing(false); setSelectedRowKeys([]); form.resetFields(); }}>
              Cancel
            </Button>
          </>
        )}
      </div>
    </div>
  );
};
